import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { Avatar, Typography } from '@mui/material';
import { EditActionIcon } from './svgIcon';
import { getI18Next } from '../../utils/helpers';

export default function DropDownMenu(props) {
  const currentLanguageCode = getI18Next();

  const inputRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [inputActive, setInputActive] = useState(false);
  const [style, setStyle] = useState({
    top: 0,
    left: 0,
  });
  const open = Boolean(anchorEl);
  // const handleClick = (event) => {
  //   const content = event.target.closest('.MuiBox-root').getBoundingClientRect();
  //   if (content.top + 180 > window.innerHeight) {
  //     setStyle({
  //       top: content.top + content.width - 180,
  //       left: content.left - 220,
  //     });
  //   } else {
  //     setStyle({
  //       top: content.top,
  //       left: content.left - 220,
  //     });
  //   }
  //   setAnchorEl(event.currentTarget);
  //   event.stopPropagation();
  // };

  const handleClick = (event) => {
    const { top: iconTop, bottom: iconBottom, right: iconRight } = event.currentTarget.getBoundingClientRect();

    const dropdownHeight = (props?.editableName || !props?.from) ? 280 : 180;
    const gap = 4;

    const shouldOpenUpward = iconBottom + dropdownHeight > window.innerHeight;

    const top = shouldOpenUpward
      ? iconTop - dropdownHeight - gap
      : iconBottom + gap;

    const right = iconRight;

    setStyle({ top, right });
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  const handleClose = (event) => {
    if (props?.templateClose) {
      props?.templateClose();
    }
    setAnchorEl(null);
    event.stopPropagation();
    setInputActive(false);
  };
  const handleEditIcon = () => {
    setInputActive(true);
    setTimeout(() => {
      inputRef.current.focus();
    }, 1000);
  };
  const handleChange = (id, name) => {
    props?.handleEditName(id, name);
  };
  const handleBluer = (e) => e.stopPropagation();
  const statusCheck = (
    id,
    status,
  ) => (props?.statusCheck ? props?.statusCheck(id, status) : false);
  return (
    <div style={{ position: 'relative' }}>
      <Box sx={
        {
          display: 'flex', alignItems: 'center', gap: '20px', textAlign: 'center',
        }
      }
      >
        <Tooltip title={props?.tooltip}>
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{
              width: '34px',
              height: '34px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              svg: {
                height: '20px !important',
                width: '20px !important',
              },
              '&:hover': !props?.hoverHide && {
                background: 'linear-gradient(180deg, rgba(11, 162, 155, 0.15) 0%, rgba(67, 180, 141, 0.15) 100%)',
                svg: {
                  height: '24px !important',
                  width: '24px !important',
                  path: {
                    fill: '#43B48D',
                    stroke: '#43B48D',
                  },
                  circle: {
                    fill: '#43B48D',
                  },
                },
              },
            }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            {props?.icon}
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.25))',
            width: '220px',
            borderRadius: '8px',
            mt: 1.5,
            // top: `${props?.top ? 505 : style.top}px !important`,
            top: `${style.top}px !important`,
            left: `${style.left}px !important`,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: currentLanguageCode === 'ar' ? 'none' : '334px',
              left: currentLanguageCode === 'ar' ? '14px' : 'none',
              width: 10,
              height: 10,
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {props?.userProfile?.name
          && (
            <>
              <MenuItem
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: 2,
                  cursor: 'default',
                  pointerEvents: 'none !important',
                  maxWidth: '270px',
                  // overflow: 'hidden',
                }}
              >
                <Avatar sx={{ width: 32, height: 31 }} src={props?.userProfile?.icon} />
                <div style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  <Typography
                    color="#212B36"
                    sx={{ fontWeight: '500' }}
                  >
                    {props?.userProfile?.name}
                  </Typography>
                  <Typography
                    color="#717880"
                    sx={{
                      fontWeight: '400',
                      whiteSpace: 'nowrap !important',
                      overflow: 'hidden !important',
                      textOverflow: 'ellipsis !important',
                    }}
                  >
                    {props?.userProfile?.email}
                  </Typography>
                </div>
              </MenuItem>
              <Divider sx={{ m: '0 !important' }} />
            </>
          )}
        {(props?.editableName || !props?.from)
          && (
            <>
              <MenuItem
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: 2,
                  maxWidth: '270px',
                  // overflow: 'hidden',
                  '&:hover': {
                    background: '#fff',
                  },
                  '&:focus-within': {
                    background: '#fff',
                  },
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div style={{ width: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  <Typography
                    color="#212B36"
                    sx={{ fontWeight: '500', display: 'flex', gap: '10px' }}
                  >
                    {
                      !inputActive
                        ? (
                          <span
                            className="title-name"
                            style={{
                              width: '80%',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {props?.value?.name || props?.value?.template_name}
                          </span>
                        ) : (
                          <input
                            value={props?.value?.name || props?.value?.template_name}
                            style={{
                              border: 'none',
                              outline: 'none',
                              flex: '1',
                              width: '100%',
                            }}
                            ref={inputRef}
                            onChange={(e) => handleChange(props?.value?.id, e.target.value)}
                            onKeyDown={handleBluer}
                            className="title-input"
                          />
                        )
                    }
                    <div
                      className="edit-icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleEditIcon}
                      role="presentation"
                    >
                      <EditActionIcon />
                    </div>
                  </Typography>
                </div>
              </MenuItem>
              <Divider sx={{ m: '0 !important' }} />
            </>
          )}
        {props?.action?.map((item, index) => {
          let value;
          if (props?.dropdown === 'tableForm') {
            const isDisabled = props?.value?.device_groups?.length > 0
              && props?.value?.devices?.length > 0
              && item?.name === 'Clone';
            value = (
              <div key={item?.id || index}>
                <MenuItem
                  sx={{
                    // padding: '10px',
                    padding: props?.from === 'device' ? '5px 15px 5px 15px' : '10px',
                    color: item?.key === 'delete' ? '#F04438' : '#101928',
                    '&:hover': {
                      background: item?.key === 'delete' ? '#FFECE5' : `
                      linear-gradient(180deg, rgba(25, 167, 153, 0.15) 0%, rgba(85, 186, 137, 0.15) 100%)
                      `,
                      color: item?.key === 'delete' ? '#F04438' : '#227735',
                    },
                  }}
                  onClick={(event) => {
                    setAnchorEl(null);
                    item?.function(item?.sendFullDetails ? props?.value : props?.value?.id, event);
                  }}
                  disabled={(item?.disabled || isDisabled) || statusCheck(item?.id, props?.value?.status)}
                >
                  <p
                    className={item?.classSpecific ? 'menu-text-warn' : 'menu-text'}
                    id={item?.id}
                  >
                    {item?.name}
                  </p>
                </MenuItem>
                {props?.divider && <Divider />}
              </div>
            );
          } else if (props?.dropdown === 'dropdown') {
            value = (
              <div key={item?.id || index}>
                {item?.key === 'logout' && <Divider />}
                <MenuItem
                  key={item?.id || index}
                  onClick={() => {
                    setAnchorEl(null);
                    item?.function(item?.code);
                  }}
                  disabled={item?.disabled || statusCheck(item?.name, props?.value?.status)}
                  sx={{ padding: props?.customPadding ? '12px 16px' : '' }}
                >
                  <p className="menu-text" style={{ color: item?.key === 'logout' ? '#E8212E' : '' }}>{item?.name}</p>
                </MenuItem>
                {props?.divider && <Divider />}
              </div>
            );
          }
          return value;
        })}
      </Menu>
    </div>
  );
}
DropDownMenu.propTypes = {
  tooltip: PropTypes.string,
  // from: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  // top: PropTypes.number.isRequired,
  action: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
      code: PropTypes.string,
      function: PropTypes.func.isRequired,
      sendFullDetails: PropTypes.bool,
      disabled: PropTypes.bool,
      // icon: PropTypes.string,
      // email: PropTypes.string,
    }),
  ).isRequired,
  userProfile: PropTypes.objectOf,
  editableName: PropTypes.bool,
  dropdown: PropTypes.string.isRequired,
  value: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    template_name: PropTypes.string.isRequired,
    status: PropTypes.string,
    devices: PropTypes.string,
    device_groups: PropTypes.string,
    template_content: PropTypes.arrayOf,
  }),
  statusCheck: PropTypes.func,
  handleEditName: PropTypes.func,
  divider: PropTypes.bool,
  customPadding: PropTypes.bool,
  hoverHide: PropTypes.bool,
  from: PropTypes.string.isRequired,
  templateClose: PropTypes.func.isRequired,
  // setIsShrunk: PropTypes.func.isRequired,
};
DropDownMenu.defaultProps = {
  value: {
    id: '',
    status: '',
  },
  tooltip: '',
  divider: false,
  editableName: false,
  statusCheck: () => false,
  handleEditName: () => { },
  userProfile: {},
  customPadding: false,
  hoverHide: true,
};
